import React from "react"
const SvgContainer = ({ children, ...svgProps }) => {
    return(
        <svg { ...svgProps } >
            {children}
        </svg>
    )
}
export default SvgContainer